import { useState } from "react";
import { Bento } from "@/components/ui/box";
import type { FactBox } from "@/components/ui/box.schema";
import type { RecordingPolicy } from "@/lib/api/tenant";

/** The configured standing notice is a read-only Fact, visible where it applies. */
export function CourseRecordingNotice({ recordingPolicy }: { recordingPolicy?: RecordingPolicy | null }) {
  const [readAt] = useState(() => new Date().toISOString());
  if (!recordingPolicy) return null;
  const notice: FactBox<RecordingPolicy> = {
    id: "recording-notice", kind: "fact", label: "Session recordings and your options", job: "Read the institution's standing recording notice and contact its support.",
    owner: { system: "imam" }, read: { status: "ready", value: recordingPolicy, readAt }, fold: "never",
    detail: () => "The institution's standing recording notice.",
    body: policy => <div className="grid max-w-prose gap-3 text-ui">{policy.standing_notice.split("\n\n").map(paragraph => <p key={paragraph}>{paragraph}</p>)}
      <p><a data-nav="" className="text-primary underline-offset-4 hover:underline" href={`mailto:${policy.support_email}`}>Contact recording support</a></p>
    </div>,
  };
  return <Bento id="course-recording-notice" journey="course-recording-notice" boxes={[notice]} />;
}
